import { getMarketIconSrc } from 'src/components/Utils/MarketIcon';
import useSWR from 'swr';
import { useMemo } from 'react';
import { useSpotMarketsLookup } from '../spotMarkets/useSpotMarketsLookup';
const JUPITER_TOKEN_LIST_API =
	'https://lite-api.jup.ag/tokens/v2/tag?query=verified';

export interface OpenToken {
	address: string;
	decimals: number;
	name: string;
	symbol: string;
	logoURI: string;
}

const WETH_TOKEN = {
	address: '7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs',
	decimals: 8,
	name: 'Wrapped Ether (Wormhole)',
	symbol: 'wETH',
	logoURI:
		'https://raw.githubusercontent.com/certusone/wormhole-token-list/main/assets/ETH_wh.png',
};

/**
 * The tokens in this list are not how we want the details to be (e.g. Jupiter shows ETH instead of wETH).
 * Hence we customize the token details for these tokens.
 */
const ADJUSTED_TOKEN_LIST = [WETH_TOKEN];

/**
 * Singleton hook that caches the open Jupiter Token List.
 *
 * Read more: https://station.jup.ag/docs/apis/token-list/token-list-api
 */
const useTokenList = () => {
	const spotMarketsLookup = useSpotMarketsLookup();
	const defaultTokenList = useMemo(() => {
		return spotMarketsLookup.map((marketConfig) => ({
			address: marketConfig.mint.toString(),
			decimals: marketConfig.precisionExp.toNumber(),
			name: marketConfig.symbol,
			symbol: marketConfig.symbol,
			logoURI: getMarketIconSrc({ baseSymbol: marketConfig.symbol }),
		}));
	}, [spotMarketsLookup]);
	const { data } = useSWR<OpenToken[]>(JUPITER_TOKEN_LIST_API, null, {
		fallbackData: defaultTokenList,
	});

	const tokenList = data
		?.filter(
			(t) =>
				!ADJUSTED_TOKEN_LIST.map((token) => token.address).includes(t.address)
		)
		.concat(ADJUSTED_TOKEN_LIST);

	return tokenList;
};

export default useTokenList;
